import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

const fadeLayerPadding: number = 12;

export const ListContainer = styled.ul<{ isOverFlowing: boolean }>`
  width: ${({ isOverFlowing }) =>
    isOverFlowing ? "calc(100% - 112px)" : "100%"};
  height: 44px;
  display: flex;
  overflow: hidden;
  scroll-behavior: smooth;
  border-radius: 4px;

  @media ${breakpoints.tablet.max.sm} {
    overflow: auto;
    padding-right: ${fadeLayerPadding}px;
  }
`;

export const Navigation = styled.div`
  width: 112px;
  flex-shrink: 0;
  display: flex;
`;

export const FadeLayer = styled.div<{
  orientation: "left" | "right";
  width: number;
}>`
  width: ${({ width }) => width}px;
  position: absolute;
  height: 44px;
  pointer-events: none;
  background-image: linear-gradient(
    to ${({ orientation }) => orientation},
    ${({ theme }) => theme.colorTokens.background.secondary} 0%,
    transparent 5%
  );

  @media ${breakpoints.tablet.max.sm} {
    background-image: linear-gradient(
      to ${({ orientation }) => orientation},
      ${({ theme }) => theme.colorTokens.background.secondary} 0%,
      transparent 20%
    );
    width: ${({ width }) => width + fadeLayerPadding}px;
  }
`;
